<script setup lang="ts">
import Header from '~/components/general/header/Header.vue';
import Footer from '~/components/general/footer/Footer.vue';
import Sprites from '~/components/general/sprites/Sprites.vue';
import Preloader from '~/components/general/preloader/Preloader.vue';
import UiUpScrollBtn from '~/components/ui/UiUpScrollBtn/UiUpScrollBtn.vue';
import UiIcon from '~/components/ui/UiIcon/UiIcon.vue';
import { useDefaultHead } from '~/composables/useDefaultHead';
import { usePreloader } from '~/composables/usePreloader';

useDefaultHead();

const {
    isPreloaderVisible,
    finishPreloaderAnimation,
} = usePreloader();
</script>

<template>
    <div class="layout-default">
        <Transition name="preloader-fade">
            <Preloader
                v-if="isPreloaderVisible"
                class="layout-default__preloader"
                @finished="finishPreloaderAnimation"
            />
        </Transition>

        <div class="layout-default__container">
            <Header />

            <main class="layout-default__content">
                <slot />
            </main>

            <Footer />

            <Sprites />

            <ClientOnly>
                <UiUpScrollBtn>
                    <template #icon>
                        <UiIcon name="ui/up" />
                    </template>
                </UiUpScrollBtn>
            </ClientOnly>
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
